import PropTypes from 'prop-types';
import { Link } from 'dibs-elements/exports/Link.tsx';

import { indexesNavigation } from '../constants/sitemapConstants.js';

import styles from '../styles/alphaNavigation.scss';

export const SitemapIndexesNavigation = ({ vertical, filterType }) => {
    const linkUrlBase = `/sitemap/${vertical}/${filterType}/`;

    return (
        <ul className={styles.alphaNav}>
            {indexesNavigation.map(index => {
                const link = `${linkUrlBase}${index.toLowerCase()}/`;
                return (
                    <li className={styles.alphaLinkWrapper} key={link}>
                        <Link className={styles.alphaLink} href={link}>
                            {index}
                        </Link>
                    </li>
                );
            })}
        </ul>
    );
};

SitemapIndexesNavigation.propTypes = {
    vertical: PropTypes.string.isRequired,
    filterType: PropTypes.string.isRequired,
};
